import { render } from "./AddRoleView.vue?vue&type=template&id=ec87e93c"
import script from "./AddRoleView.vue?vue&type=script&lang=js"
export * from "./AddRoleView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__